document.addEventListener('DOMContentLoaded', () => {

  setTimeout(() => {
    document.querySelectorAll('.variant-picker__form .iurop-color-options input:checked').forEach(option => {
      if (option.closest('product-card')) return;
      const galleryScope = option.closest('.product-information, .quick-add-modal__content, featured-product-information');
      if (!galleryScope) return;
      const variantValue = option.value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '-')
        .toLowerCase();
      const elements = Array.from(galleryScope.querySelectorAll('.custom__thumbnail-control, .custom-media-image-product'));
      const hasMatchingMedia = elements.some(el => el.classList.contains(variantValue));
      elements.forEach(el => {
        el.classList.toggle('not-show', hasMatchingMedia && !el.classList.contains(variantValue));
      });
    });

  }, 300);


  if (!sessionStorage.getItem('open-cart-drawer')) return;
  sessionStorage.removeItem('open-cart-drawer');

  setTimeout(() => {
    document.querySelector(".cart-drawer .header-actions__action").click();
  }, 300);

});